import request from '@/utils/request.js'
import activityRequest from '@/utils/activityRequest.js'
import Config from '@/config/app.js'

let wxUseUrl = Config.wxUseUrl;
/**
 *  H5分享-工作室
 * @param params
 * @returns {AxiosPromise}
 */
export function getWorkstationDetailForShare(params) {
    return request({
        closeNetworkError: true,
        url: '/workstationService/api/h5/workstation/getWorkstationDetailForShare',
        method: 'post',
        data: params
    })
}

/**
 *
 * 推荐工作室服务产品列表-分页
 * @param params
 * @returns {AxiosPromise}
 */
export function getStudioServiceProductList(params) {
    return request({
        closeNetworkError: true,
        url: '/tradeService/api/h5/share/getStudioServiceProductList',
        method: 'post',
        data: params
    })
}

/**
 * 发现-首页-推荐服务产品订单详情(未接)
 * @param params
 * @returns {AxiosPromise}
 *
 */
export function getServiceProductOrderRecommendDetail(params) {
    return request({
        closeNetworkError: true,
        url: '/tradeService/api/app/orderServiceProduct/getServiceProductOrderRecommendDetail',
        method: 'post',
        data: params
    })
}

/**
 * 获取文章具体内容
 * @param params
 * @returns {AxiosPromise}
 */
export function getArtcleRecommend(params) {
    return request({
        closeNetworkError: true,
        url: '/operateService/api/app/lines/getArtcleRecommend',
        method: 'post',
        data: params
    })
}

/**
 * 微信登录
 * /api/app/userNurse/loginWx
 * @param params
 * @returns {AxiosPromise}
 */
export function loginWx(params) {
    return request({
        closeNetworkError: true,
        closeInterceptors: true,
        noToken:true,
        url: '/userService/api/app/userNurse/loginWx',
        method: 'post',
        data: params
    })
}

/**
 * 试听课程微信登录--春耕活动
 * /api/app/common/ext/getOpenIdByCode
 * @param params
 * @returns {AxiosPromise}
 */
export function getOpenIdByCode(params) {
    return activityRequest({
        closeNetworkError: true,
        closeInterceptors: true,
        url: '/activityService/api/app/common/ext/getOpenIdByCode',
        method: 'post',
        data: params
    })
}

/**
 * 获取试听课程知识点数组--春耕活动
 * /api/app/spring/ext/listKnowledgeForAudition
 * @param params
 * @returns {AxiosPromise}
 */
export function listKnowledgeForAudition(params) {
    return activityRequest({
        // closeNetworkError: true,
        // closeInterceptors: true,
        url: '/studyService/api/app/spring/ext/listKnowledgeForAudition',
        method: 'post',
        data: params
    })
}

/**
 * 微信授权登录获取验证码
 * @param params
 * @returns {AxiosPromise}
 */
export function loginWxAuthorizeSendCode(params) {
    return request({
        closeNetworkError: true,
        url: '/userService/api/app/userNurse/loginWxAuthorizeSendCode',
        method: 'post',
        data: params
    })
}

/**
 * 微信授权登录验证验证码
 * @param params
 * @returns {AxiosPromise}
 */
export function loginWxAuthorizeVerifyCode(params) {
    return request({
        closeNetworkError: true,
        url: '/userService/api/app/userNurse/loginWxAuthorizeVerifyCode',
        method: 'post',
        data: params
    })
}

/**
 * 手机验证码登录获取验证码
 * @param params
 * @returns {AxiosPromise}
 */
export function loginPhoneSendCode(params) {
    return request({
        closeNetworkError: true,
        url: '/userService/api/app/userNurse/loginPhoneSendCode',
        method: 'post',
        data: params
    })
}

/**
 * 手机验证码登录验证验证码
 * @param params
 * @returns {AxiosPromise}
 */
export function loginPhoneVerifyCode(params) {
    return request({
        closeNetworkError: true,
        url: '/userService/api/app/userNurse/loginPhoneVerifyCode',
        method: 'post',
        data: params
    })
}

/**
 *
 获取课程介绍
 * @param params
 * @returns {AxiosPromise}
 */
export function getCourse(params) {
    return request({
        closeLoading: true,
        url: '/studyService/api/h5/course/get',
        method: 'post',
        data: params
    })
}

/**
 *
 * 订阅/取消订阅课程
 * @param params
 * @returns {AxiosPromise}
 */
export function subscibe(params) {
    return request({
        url: '/studyService/api/h5/course/subscibe',
        method: 'post',
        data: params
    })
}

/**
 *
 * /qiyu/user/getNurseUserUid
 * 护士用户uid
 * @param params
 * @returns {AxiosPromise}
 */
export function getNurseUserUid(params) {
    return request({
        url: '/operateService/api/user/md5/getNurseUserUid',
        method: 'post',
        data: params
    })
}

/**
 *
 * 优惠券可用列表
 * @param params
 * @returns {AxiosPromise}
 */
export function listUserNurseCouponUsaApp(params) {
    return request({
        url: '/operateService/api/app/couponApp/listUserNurseCouponUsaApp',
        method: 'post',
        data: params
    })
}
export function getCouponDetailByID(params) {
    return request({
        closeLoading:true,
        url: '/operateService/api/app/couponApp/getCouponDetailByID',
        method: 'post',
        data: params
    })
}

export function receiveCouponByID(params) {
    return request({
        url: '/operateService/api/app/couponApp/receiveCouponByID',
        method: 'post',
        data: params
    })
}

export function createHlGkkCouponClaimToken(params) {
    return request({
        closeLoading: true,
        url: '/operateService/api/app/couponApp/createHlGkkCouponClaimToken',
        method: 'post',
        data: params
    })
}


/**
 *
 *  App分享h5课程结算
 * @param params
 * @returns {AxiosPromise}
 */
export function shareH5CourseOrderBuy(params) {
    return request({
        closeLoading: true,
        url: '/tradeService/api/app/orderCommodity/shareH5CourseOrderBuy',
        method: 'post',
        data: params
    })
}

/**
 *
 * App分享h5课程支付
 * @param params
 * @returns {AxiosPromise}
 */
export function shareH5CourseOrderPay(params) {
    return request({
        closeLoading: true,
        url: '/tradeService/api/app/orderCommodity/shareH5CourseOrderPay',
        method: 'post',
        data: params
    })
}

export function shareH5CourseOrderPay2(params) {
    return request({
        closeLoading: true,
        url: '/tradeService/api/app/orderCommodity/shareH5CourseOrderPay2',
        method: 'post',
        data: params
    })
}


/**
 * 长链接转为短参数
 * @param params
 * @returns {AxiosPromise}
 */
export function shortUrl(params) {
    return request({
        closeLoading: true,
        url: wxUseUrl + 'short/url?isshortSence=true',
        method: 'post',
        data: params
    })
}

/**
 * 大对象转短参数
 * @param params
 * @returns {AxiosPromise}
 */
export function shortParams(params) {
    return request({
        url: wxUseUrl + 'short/params',
        method: 'post',
        data: params
    })
}

/**
 *  短参数转长链接或对象
 * @param params
 * @returns {AxiosPromise}
 */
export function longParams(params) {
    return request({
        url: wxUseUrl + 'short/slp/'+params,
        method: 'get',
    })
}

/**
 * 获取opendId
 * mp
 * @param params
 * @returns {AxiosPromise}
 */
export function getUserInfoByCode(params) {
    return request({
        url: wxUseUrl + 'hsjmp/mp/getUserInfoByCode',
        method: 'get',
        params: params
    })
}


/**
 * 获取二维码
 * @param params
 * @returns {AxiosPromise}
 */
export function getQrCode(params) {
    return request({
        url: wxUseUrl + 'miniapp/miniap/create/qrcode',
        method: 'get',
        params: params
    })
}


/**
 * 生成口令
 * @param params
 * @returns {AxiosPromise}
 */
export function generatePasswordQrcode(params) {
    return request({
        url: wxUseUrl + 'jkhh/kouling/get?isqrCode=true',
        method: 'post',
        data: params
    })
}

/**
 * 生成口令
 * @param params
 * @returns {AxiosPromise}
 */
export function generatePassword(params) {
    return request({
        url: wxUseUrl + 'jkhh/kouling/get',
        method: 'post',
        data: params
    })
}

/**
 * 解析口令
 * @param params
 * @returns {AxiosPromise}
 */
export function parsePassword(params) {
    return request({
        url: wxUseUrl + 'jkhh/kouling/parse',
        method: 'get',
        params: params
    })
}
